export interface AuthCredentials {
	clientId: string;
	secretId: string;
	url: string;
}
let credentials = {} as AuthCredentials;
class AuthCredentialsService {
	static get = (): AuthCredentials => {
		return credentials;
	};
	static init = (c: AuthCredentials) => {
		credentials = c;
	};
}
export { AuthCredentialsService };
